import { createContext, useState, useContext } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [languageContext, setLanguageContext] = useState("en"); // Idioma por defecto

  //console.log('estado:',languageContext);
  return (
    <LanguageContext.Provider value={{ languageContext, setLanguageContext  }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
